var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 11.6,
    viewBox: "0 0 17.999 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M62.032,55.646C61.89,55.432,58.475,50.4,53.2,50.4s-8.689,5.032-8.832,5.246a1,1,0,0,0,0,1.109C44.511,56.969,47.926,62,53.2,62s8.69-5.031,8.832-5.245A1,1,0,0,0,62.032,55.646ZM55.4,54.6a2.2,2.2,0,1,1-2.2-2.2A2.2,2.2,0,0,1,55.4,54.6ZM53.2,60c-3.271,0-5.784-2.625-6.745-3.8a12.631,12.631,0,0,1,2.628-2.42,4.2,4.2,0,1,0,8.317.82,4.254,4.254,0,0,0-.082-.82,12.647,12.647,0,0,1,2.627,2.42C58.984,57.375,56.472,60,53.2,60Z",
    transform: "translate(-44.201 -50.4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeen);
export default __webpack_public_path__ + "static/media/seen.8933df9e195cf21b8f8a69edd26368f8.svg";
export { ForwardRef as ReactComponent };